export enum SubmissionState {
    Idle,
    Pending,
    Success
}
